import { Flex } from '@radix-ui/themes';

export default Flex;
